(function () {
  'use strict';

  /* @ngdoc object
   * @name myMemberships.sendReward
   * @description
   *
   */
  angular
    .module('myMemberships.sendReward', [
      'ui.router'
    ]);
}());
